import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '@core/services';
import { TranslateService } from '@ngx-translate/core';
import {
  UserAgreementDialogComponent
} from '@shared/components/dialogs/user-agreement-dialog/user-agreement-dialog.component';
import {
  PublicOfferDialogComponent
} from '@shared/components/dialogs/public-offer-dialog/public-offer-dialog.component';
import {SupportDialogComponent} from '@shared-v3/dialogs/support-dialog/support-dialog.component';
import { DocDialogService } from '@core/services/doc-dialog.service';

@Component({
  selector: 'ms-dashboard-sidebar-student',
  templateUrl: './dashboard-sidebar-student.component.html',
  styleUrls: ['./dashboard-sidebar-student.component.scss'],
  standalone: false,
})
export class DashboardSidebarStudentComponent {
  get canSelfPay(): boolean {
    return this._userService.user?.canSelfPay ?? false;
  }

  get canViewRating(): boolean {
    return this._userService.user?.canViewRating ?? true;
  }

  get isUkrainianLanguage(): boolean {
    const lang = (
      this._translateService.currentLang ||
      this._translateService.defaultLang ||
      ''
    ).toLowerCase();

    return lang.startsWith('ua') || lang.startsWith('uk');
  }

  constructor(
    protected readonly _matDialog: MatDialog,
    private readonly _userService: UserService,
    private readonly _docDialogService: DocDialogService,
    private readonly _translateService: TranslateService,
  ) {}

  public handleTechSupportButtonClick(): void {
    this._matDialog.open(SupportDialogComponent, {
      width: '90vw',
      maxWidth: '500px',
      hasBackdrop: true,
      panelClass: 'support-dialog',
      backdropClass: 'blur-backdrop',
    });
  }

  public handleUserAgreementButtonClick(): void {
    this._docDialogService.open('personal-data');
  }

  public handlePublicOfferButtonClick(): void {
    this._docDialogService.open('offer');
  }
}
